export interface OccupancyRow {
  vehicle_id: string;
  start_date?: string | null;
  end_date?: string | null;
  blocked_date?: string | null;
}

const toDateKey = (value: string): string => value.slice(0, 10);

/** Inclusive overlap: ranges collide when each starts on or before the other ends. */
export const datesOverlap = (
  startA: string,
  endA: string,
  startB: string,
  endB: string
): boolean => {
  const aStart = toDateKey(startA);
  const aEnd = toDateKey(endA);
  const bStart = toDateKey(startB);
  const bEnd = toDateKey(endB);
  return aStart <= bEnd && aEnd >= bStart;
};

export const collectConflictingVehicleIds = (
  rows: OccupancyRow[],
  rangeStart: string,
  rangeEnd: string
): string[] => {
  const ids = new Set<string>();
  const startKey = toDateKey(rangeStart);
  const endKey = toDateKey(rangeEnd);

  for (const row of rows) {
    if (!row.vehicle_id) continue;

    if (row.blocked_date) {
      const blocked = toDateKey(row.blocked_date);
      if (blocked >= startKey && blocked <= endKey) {
        ids.add(row.vehicle_id);
      }
      continue;
    }

    if (row.start_date && row.end_date && datesOverlap(row.start_date, row.end_date, startKey, endKey)) {
      ids.add(row.vehicle_id);
    }
  }

  return [...ids];
};
